import script from "./AUploadSlotTrigger.vue?vue&type=script&setup=true&lang=js"
export * from "./AUploadSlotTrigger.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__